<template>
  <div
    class="overflow-y-auto"
    :class="maxHeight"
    @scroll="fetchReviewsNextPage"
  >
    <div
      v-if="loading"
      class="animate-pulse mt-6"
    >
      <div class="mt-2">
        <div class="flex flex-row mt-2">
          <div class="rounded-full bg-neutral-200 h-10 w-10" />
          <div class="ml-3 my-auto w-10 h-5 bg-neutral-200 rounded" />
        </div>
        <div class="mt-4 h-5 bg-neutral-200 rounded w-80" />
        <div class="mt-2 h-5 bg-neutral-200 rounded w-60" />
      </div>

      <div class="mt-6">
        <div class="flex flex-row mt-2">
          <div class="rounded-full bg-neutral-200 h-10 w-10" />
          <div class="ml-3 my-auto w-10 h-5 bg-neutral-200 rounded" />
        </div>
        <div class="mt-4 h-5 bg-neutral-200 rounded w-80" />
      </div>
    </div>

    <div
      v-if="hasReviews"
      class="py-8 lg:py-3"
    >
      <div
        v-for="(review, index) in reviews"
        :key="review.uuid"
        :class="{ 'mt-8 lg:mt-4': index > 0 }"
        class="lg:border lg:p-5 rounded-lg flex flex-col lg:flex-col-reverse gap-3"
      >
        <div class="flex flex-row">
          <vetster-client-image
            :name="review.author"
            size="sm"
            no-margin
          />
          <div class="flex flex-col justify-center ml-3 *:text-xs">
            <p class="font-medium text-neutral-900">
              {{ review.author }} {{ review.author_last_name }}
            </p>
            <p class="text-neutral-500">
              {{ getReviewDate(review.created_at) }}
            </p>
          </div>
        </div>

        <vetster-description-item :description="`${review.body}`" />
      </div>
    </div>
  </div>
</template>

<script>
import size from 'lodash/size';
import { DateTime } from 'luxon';

import VetsterClientImage from '@/brand-components/VetsterClientImage';
import VetsterDescriptionItem from '@/brand-components/VetsterDescriptionItem';
import ParseErrors from '@/mixins/ParseErrors';

export default {
  name: 'VetsterPxReviewList',

  components: {
    VetsterClientImage,
    VetsterDescriptionItem,
  },

  mixins: [ParseErrors],

  props: {
    partner: {
      type: Object,
      required: true,
    },
    maxHeight: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      currentReviewsPage: 1,
      lastReviewsPage: null,
      reviews: [],
      loading: false,
    };
  },

  computed: {
    hasReviews() {
      return size(this.reviews) > 0;
    },
  },

  async created() {
    await this.setupReviews();
  },

  methods: {
    fetchReviews(page) {
      return this.$api.get(`p/partner/${this.partner.uuid}/reviews`, {
        params: {
          page,
          perPage: 10,
        },
      });
    },

    fetchesReviewsNextPage(el) {
      return this.currentReviewsPage < this.lastReviewsPage && this.isScrollBottom(el);
    },

    async fetchReviewsNextPage(event) {
      if (!this.fetchesReviewsNextPage(event.target)) {
        return;
      }

      this.currentReviewsPage++;

      try {
        const response = await this.fetchReviews(this.currentReviewsPage);
        this.reviews.push(...response.data.data);
      } catch (e) {
        //
      }
    },

    getReviewDate(timestamp) {
      return DateTime.fromISO(timestamp)
        .toLocaleString({
          month: 'long',
          year: 'numeric',
        });
    },

    isScrollBottom(el) {
      const { scrollTop, offsetHeight, scrollHeight } = el;

      return (scrollTop + offsetHeight) >= (scrollHeight - 100);
    },

    async setupReviews() {
      try {
        this.loading = true;
        const response = await this.fetchReviews(1);
        this.reviews = response.data.data;
        this.lastReviewsPage = response.data.meta.last_page;
      } catch (e) {
        this.showError(e, true);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
